import logo from "../../../../../../assets/img/logo-header.png";
import { AiOutlineTwitter, AiOutlineInstagram } from "react-icons/ai";
import {ImInstagram} from "react-icons/im";
import {FaDiscord} from "react-icons/fa";
// footer widget data
export const newsLetterData = [
  {
    subTitle: "NEWSLETTER",
    title: "Join Our Newsletter",
    description:
      "You never know what you might get from us. We probably won't send you anything to crazy!",
    logo: logo,
    description2:
      "Thank you for checking out our site! We would love for you to become part of our herd!",
    socialIcons: [
      {
        link: "https://twitter.com/moosesocietynft",
        icon: <AiOutlineTwitter />,
      },
      {
        link: "https://www.instagram.com/moosesocietynft/",
        icon: <AiOutlineInstagram />,
      },
      {
        link: "https://www.twitch.tv/moosesociety",
        icon: <ImInstagram />,
      },
      {
        link: "https://discord.com/invite/zXtyA6F6KP",
        icon: <FaDiscord />,
      },
    ],
    quickText: "Quick Menu",
    menuList: ["Home", "Terms & Conditions", "Contact US", "Story"],
  },
];
